
import { toast } from "@/components/ui/sonner";
import { clearDecisionTimers } from "./decisionScheduler";

// Reset simulation state
export const resetSimulation = (
  timerRef: React.MutableRefObject<NodeJS.Timeout | null>,
  decisionTimersRef: React.MutableRefObject<NodeJS.Timeout[]>,
  isSimulating: boolean,
  yearProgress: number,
  setDecisionsThrottled: React.Dispatch<React.SetStateAction<boolean>>,
  setLastDecisionTime: React.Dispatch<React.SetStateAction<number | null>>,
  timeLeft: number,
  yearDuration: number,
  setDecisionTimerFired: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
) => {
  if (timerRef.current) {
    clearInterval(timerRef.current);
  }
  
  // Clear decision timers
  clearDecisionTimers(decisionTimersRef.current);
  decisionTimersRef.current = [];
  
  // Reset all state
  setDecisionsThrottled(false);
  setLastDecisionTime(null);
  setDecisionTimerFired({});
  
  toast(`Simulation reset`, {
    description: "The simulation has been reset. You can now advance time again.",
    duration: 3000,
  });
};
